import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Report } from '../../models/report';
import { ReportService } from '../../services/report.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastService } from 'src/app/services/toast.service';
import { User } from 'src/app/models/user';

@Component({
  selector: 'app-reports-list',
  templateUrl: './reports.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./reports.component.scss'],
  providers: [ReportService],
  standalone: false,
})
export class ReportsComponent implements OnInit, OnDestroy {

  componentDestroyed$ = new Subject<boolean>();
  reportList: Report[] = [];
  selectedReport: Report;

  gettingReports = false;
  haveReports = false;

  constructor(
    protected reportService: ReportService,
    protected toastService: ToastService,
    private router: Router,
    private user: User,
    ){  }

  ngOnInit(): void {
    this.gettingReports = true;
    this.haveReports = false;
    this.reportService.getActiveReports()
    .pipe(takeUntil(this.componentDestroyed$))
    .subscribe(
      (data) => {
        if (data != null) {
          data.forEach(r => {
            this.reportList.push(new Report(r));
          });
          this.haveReports = true;
        }
        else {
          this.toastService.toastCreate('No Reports Returned.', 'Warning');
        }
        this.gettingReports = false;
      },
      (_error) => {
        this.toastService.toastCreate('Reports failed to return.', 'Danger');
        this.gettingReports = false;
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  public selectReport(r: Report): void {
    this.selectedReport = r;
    if (this.selectedReport.isCustomReport) {
      if (this.selectedReport?.routerUrl == '' || this.selectedReport?.routerUrl == undefined) {
        this.toastService.toastCreate('Report is Custom Report but Router URL not setup.', 'Warning');
      }
      else {
        this.router.navigate([this.selectedReport?.routerUrl]);
      }
    }
    else {
      this.router.navigate(['/report-view/', this.selectedReport.reportId]);
    }

  }

  canSelectReport(r: Report): boolean {
    var rc = true;

    var reportTypeName = r.reportTypeName.toLowerCase();

    if (reportTypeName.includes('baseendpointmapping')) {
      rc = this.user.checkAccess(['LOSTalker.BaseMapping']);
    }
    else if (reportTypeName.includes('basemapping')) {
      rc = this.user.checkAccess(['LOSTalker.BaseMapping']);
    }
    else if (reportTypeName.includes('changelog')) {
      rc = this.user.checkAccess(['LOSTalker.Admin']);
    }
    else if (reportTypeName.includes('clientcontract')) {
      rc = this.user.checkAccess(['LOSTalker.Client']);
    }
    else if (reportTypeName.includes('custom')) {
      rc = this.user.checkAccess(['LOSTalker.Admin']);
    }
    else if (reportTypeName.includes('genericendpoint')) {
      rc = this.user.checkAccess(['LOSTalker.BaseMapping']);
    }
    else if (reportTypeName.includes('integrationerrormessage')) {
      rc = this.user.checkAccess(['LOSTalker.DevOps']);
    }
    else if (reportTypeName.includes('integrationerror')) {
      rc = this.user.checkAccess(['LOSTalker.DevOps']);
    }
    else if (r.title.toLowerCase().includes('los data source')) {
      rc = this.user.checkAccess(['LOSTalker.Reporting']);
    }
    else if (reportTypeName.includes('integrationinformation')) {
      rc = this.user.checkAccess(['LOSTalker.Client']);
    }
    else if (reportTypeName.includes('integration')) {
      rc = this.user.checkAccess(['LOSTalker.Integration']);
    }

    return rc;
  }

}
